<div class="flex flex-1 flex-col gap-3">
  <cmi-filing-steps [steps]="steps" />

  <!-- mt-auto drops it to the bottom of a short flow, sticky keeps it there
       once the flow is long enough to scroll, and the negative margins escape
       the shell's padding so it spans the pane and sits flush at its edge.
       -bottom-4 matches -mb-4: sticky offsets measure the margin box, so
       without it the bar would stop a padding's width short of the edge. -->
  <div
    class="sticky -bottom-4 -mx-4 -mb-4 mt-auto border-t border-cmi-gray-light bg-white px-4 py-3">
    <cmi-mail-upload
      class="block"
      [dossierGuid]="steps.selectedDossier()?.guid ?? null"
      [folder]="steps.folderTarget()"
      [felder]="felder()"
      [fieldsComplete]="steps.fieldsComplete()"
      (uploaded)="onUploaded()" />
  </div>
</div>
